import NotAllowed from "../../../../../components/error/not-allowed";
import { Permission } from "../../../../permission";
import { PERMISSIONS } from "../../../../role-control/constants";
import AbsenceLetterDetail from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import { TerminationContractCreate } from "../../absence-letter/pages/termination-contract/termination-contract-create";
import { TerminationContractEdit } from "../../absence-letter/pages/termination-contract/termination-contract-edit";
import { TerminalContractList } from "../../absence-letter/pages/termination-contract/termination-contract-list";

export const terminationContractDADRoutes = {
  terminationContractDADPage: {
    isAdmin: false,
    title: "6. Đơn xin chấm dứt HĐLĐ",
    path: "/procedure/termination-contract-dad",
    parentId: "procedure",
    component: () => {
      return (
        <TerminalContractList />

        // <Permission record={{ [PERMISSIONS["TERMINATION_CONTRACT_DAD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <TerminalContractList />
        // </Permission>
      );
    },
  },
  createTerminationContractDADPage: {
    isAdmin: false,
    path: "/procedure/termination-contract-dad/create",
    parentId: "procedure",
    component: TerminationContractCreate,
  },
  detailTerminationContractDADPage: {
    isAdmin: false,
    path: "/procedure/termination-contract-dad/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editTerminationContractDADPage: {
    isAdmin: false,
    path: "/procedure/termination-contract-dad/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: TerminationContractEdit,
  },
};
